import { wccModules } from "enums/wccModules";
import { inject, injectable } from "inversify";
import { NodeTracker } from 'managers/nodes/tracker';
import { EffectsContainer } from "mixins/withEffects";
import WCCSliderItemVM from "../base/base";
import './adaptive.html';
import WCCSliderAdaptiveItem from "./adaptive.model";

@injectable()
export default class WCCSliderAdaptiveItemVM<T> extends WCCSliderItemVM<T> {
    bodyNode = ko.observable<HTMLElement>();

    constructor(
        @inject(wccModules.componentConfig) model: WCCSliderAdaptiveItem<T>,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(model, info, effects);

        const { width: bodyWidth } = new NodeTracker({ node: this.bodyNode });

        effects.saveState(model.width);

        effects.register(bodyWidth => {
            model.width(bodyWidth);
        }, [bodyWidth]);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-slider__item--adaptive': true
            },

            'attr': {
                'data-width': model.width
            }
        });
    }
}